module.exports = __webpack_public_path__ + "static/slide5-318x245-c62e65575f962243fca4281d8f1bf2e6.gif";